import { useEffect, useRef } from 'react';
import { useErrorBoundary } from 'react-error-boundary';

import { ApiError } from 'components/ErrorBoundary';
import Typography from 'components/Typography';
import { htmlId } from 'utils/html';

import { DEFAULT_MAX_LOADING_TIME } from './constants';
import { Container, LoadingAnimation } from './Loader.styles';
import { LoaderProps } from './Loader.types';

const Loader = (props: LoaderProps) => {
  const { isLoading, timer = { enabled: true, maxWaitTimeMs: DEFAULT_MAX_LOADING_TIME } } = props;
  const { enabled: timerEnabled, maxWaitTimeMs } = timer;

  const { showBoundary } = useErrorBoundary();
  const errorTimeoutRef = useRef<NodeJS.Timer>();

  useEffect(() => {
    if (isLoading && timerEnabled) {
      errorTimeoutRef.current = setTimeout(() => {
        const err = new ApiError(`Failed to finish loading before timeout (${maxWaitTimeMs} ms).`);
        showBoundary(err);
      }, maxWaitTimeMs);
      return;
    }

    clearTimeout(errorTimeoutRef.current);
  }, [isLoading]);

  // Cleanup Error Timeout on unmount
  useEffect(() => {
    return () => clearTimeout(errorTimeoutRef.current);
  }, []);

  if (!isLoading) return <>{props.children}</>;

  return (
    <Container id={htmlId('loader-container')}>
      <LoadingAnimation id={htmlId('loader-loading-animation')} />
      <Typography>Loading...</Typography>
    </Container>
  );
};

export default Loader;
